import $ from 'jquery';

$(document).ready(function() {
    $('.js-breadcrumbs-item').each(function() {
        if (!($(this).find('a').attr('href'))) {
            $(this).find('a').addClass('no-link');
            $(this).find('a').removeAttr('href');
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/general/breadcrumbs.js